import styled from 'styled-components';

export const MenuContainer = styled.div`
  box-sizing: border-box;
  width: 300px;
  height: 100vh;
  display: flex;
  position: fixed;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => {
    return theme.colors.black;
  }};
  padding: 20px;
`;

export const WrapperFooter = styled.div`
  width: 100%;
`;
